import React from 'react';
import { Navigate } from 'react-router-dom';
import { ComplexRoute } from '../../components/Routes/Routes';
import UsersRouter from './subrouters/Users';
import userRoutes from './subrouters/Users/routes';
import VehiclesRouter from './subrouters/Vehicles';
import vehicleRoutes from './subrouters/Vehicles/routes';
import ProfileRouter from './subrouters/Profile/Profile.router';
import profileRoutes from './subrouters/Profile/routes';
import UserIcon from 'icons/User.icon';
import CarIcon from 'icons/Car.icon';
import SettingsIcon from 'icons/Settings.icon';
import Fleets from './pages/Fleets';
import GarageIcon from 'icons/Garage.icon';

export default [
  {
    isDashRoute: true,
    label: 'settings',
    path: 'profile',
    element: ProfileRouter,
    routes: profileRoutes,
    authorized: true,
    Icon: SettingsIcon,
  },
  {
    isDashRoute: true,
    path: 'users',
    label: 'users',
    element: UsersRouter,
    routes: userRoutes,
    Icon: UserIcon,
    authorized: true,
  },
  {
    isDashRoute: true,
    path: 'vehicles',
    label: 'vehicles',
    element: VehiclesRouter,
    routes: vehicleRoutes,
    authorized: true,
    Icon: CarIcon,
  },
  {
    isDashRoute: true,
    path: 'fleets',
    label: 'fleets',
    element: Fleets,
    authorized: true,
    Icon: GarageIcon,
  },
  {
    index: true,
    element: <Navigate to="vehicles" replace />,
  },
  {
    path: '*',
    element: () => `not found`,
  },
] as Array<ComplexRoute>;
